import Icon from '@ant-design/icons';

import { ReactComponent as MicrophoneIcon } from './svgs/microphone.svg';

const Microphone = props => {
  return <Icon component={MicrophoneIcon} {...props} />;
};

export default Microphone;
